/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addScoringParameters } from '../fn/scoring-parameters/add-scoring-parameters';
import { AddScoringParameters$Params } from '../fn/scoring-parameters/add-scoring-parameters';
import { bulkUpdateScoringParameters } from '../fn/scoring-parameters/bulk-update-scoring-parameters';
import { BulkUpdateScoringParameters$Params } from '../fn/scoring-parameters/bulk-update-scoring-parameters';
import { deleteScoringParameters } from '../fn/scoring-parameters/delete-scoring-parameters';
import { DeleteScoringParameters$Params } from '../fn/scoring-parameters/delete-scoring-parameters';
import { findByMetricType } from '../fn/scoring-parameters/find-by-metric-type';
import { FindByMetricType$Params } from '../fn/scoring-parameters/find-by-metric-type';
import { getAllScoringParameters } from '../fn/scoring-parameters/get-all-scoring-parameters';
import { GetAllScoringParameters$Params } from '../fn/scoring-parameters/get-all-scoring-parameters';
import { getScoringParameters } from '../fn/scoring-parameters/get-scoring-parameters';
import { GetScoringParameters$Params } from '../fn/scoring-parameters/get-scoring-parameters';
import { ScoringParameters } from '../models/scoring-parameters';
import { updateScoringParameters } from '../fn/scoring-parameters/update-scoring-parameters';
import { UpdateScoringParameters$Params } from '../fn/scoring-parameters/update-scoring-parameters';

@Injectable({ providedIn: 'root' })
export class ScoringParametersService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getScoringParameters()` */
  static readonly GetScoringParametersPath = '/api/scoringparameters';

  /**
   * Get Scoring Parameters.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getScoringParameters()` instead.
   *
   * This method doesn't expect any request body.
   */
  getScoringParameters$Response(params?: GetScoringParameters$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ScoringParameters>>> {
    return getScoringParameters(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Scoring Parameters.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getScoringParameters$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getScoringParameters(params?: GetScoringParameters$Params, context?: HttpContext): Observable<Array<ScoringParameters>> {
    return this.getScoringParameters$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ScoringParameters>>): Array<ScoringParameters> => r.body)
    );
  }

  /** Path part for operation `addScoringParameters()` */
  static readonly AddScoringParametersPath = '/api/scoringparameters';

  /**
   * Add Scoring Parameters.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addScoringParameters()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addScoringParameters$Response(params: AddScoringParameters$Params, context?: HttpContext): Observable<StrictHttpResponse<ScoringParameters>> {
    return addScoringParameters(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Scoring Parameters.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addScoringParameters$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addScoringParameters(params: AddScoringParameters$Params, context?: HttpContext): Observable<ScoringParameters> {
    return this.addScoringParameters$Response(params, context).pipe(
      map((r: StrictHttpResponse<ScoringParameters>): ScoringParameters => r.body)
    );
  }

  /** Path part for operation `getAllScoringParameters()` */
  static readonly GetAllScoringParametersPath = '/api/scoringparameters/all';

  /**
   * Get All Scoring Parameters.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllScoringParameters()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllScoringParameters$Response(params?: GetAllScoringParameters$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ScoringParameters>>> {
    return getAllScoringParameters(this.http, this.rootUrl, params, context);
  }

  /**
   * Get All Scoring Parameters.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllScoringParameters$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllScoringParameters(params?: GetAllScoringParameters$Params, context?: HttpContext): Observable<Array<ScoringParameters>> {
    return this.getAllScoringParameters$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ScoringParameters>>): Array<ScoringParameters> => r.body)
    );
  }

  /** Path part for operation `bulkUpdateScoringParameters()` */
  static readonly BulkUpdateScoringParametersPath = '/api/scoringparameters/bulk';

  /**
   * Bulk Update Scoring Parameters.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bulkUpdateScoringParameters()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkUpdateScoringParameters$Response(params: BulkUpdateScoringParameters$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ScoringParameters>>> {
    return bulkUpdateScoringParameters(this.http, this.rootUrl, params, context);
  }

  /**
   * Bulk Update Scoring Parameters.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bulkUpdateScoringParameters$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkUpdateScoringParameters(params: BulkUpdateScoringParameters$Params, context?: HttpContext): Observable<Array<ScoringParameters>> {
    return this.bulkUpdateScoringParameters$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ScoringParameters>>): Array<ScoringParameters> => r.body)
    );
  }

  /** Path part for operation `findByMetricType()` */
  static readonly FindByMetricTypePath = '/api/scoringparameters/metricType/{metricType}';

  /**
   * Find By Metric Type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByMetricType()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByMetricType$Response(params: FindByMetricType$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ScoringParameters>>> {
    return findByMetricType(this.http, this.rootUrl, params, context);
  }

  /**
   * Find By Metric Type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findByMetricType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByMetricType(params: FindByMetricType$Params, context?: HttpContext): Observable<Array<ScoringParameters>> {
    return this.findByMetricType$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ScoringParameters>>): Array<ScoringParameters> => r.body)
    );
  }

  /** Path part for operation `updateScoringParameters()` */
  static readonly UpdateScoringParametersPath = '/api/scoringparameters/{scoringParameterId}';

  /**
   * Update Scoring Parameters.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateScoringParameters()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateScoringParameters$Response(params: UpdateScoringParameters$Params, context?: HttpContext): Observable<StrictHttpResponse<ScoringParameters>> {
    return updateScoringParameters(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Scoring Parameters.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateScoringParameters$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateScoringParameters(params: UpdateScoringParameters$Params, context?: HttpContext): Observable<ScoringParameters> {
    return this.updateScoringParameters$Response(params, context).pipe(
      map((r: StrictHttpResponse<ScoringParameters>): ScoringParameters => r.body)
    );
  }

  /** Path part for operation `deleteScoringParameters()` */
  static readonly DeleteScoringParametersPath = '/api/scoringparameters/{scoringParameterId}';

  /**
   * Delete Scoring Parameters.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteScoringParameters()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteScoringParameters$Response(params: DeleteScoringParameters$Params, context?: HttpContext): Observable<StrictHttpResponse<ScoringParameters>> {
    return deleteScoringParameters(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Scoring Parameters.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteScoringParameters$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteScoringParameters(params: DeleteScoringParameters$Params, context?: HttpContext): Observable<ScoringParameters> {
    return this.deleteScoringParameters$Response(params, context).pipe(
      map((r: StrictHttpResponse<ScoringParameters>): ScoringParameters => r.body)
    );
  }

}
